import { FC, Suspense } from 'react';
import { ScrollRestoration } from 'react-router-dom';

import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { Loader } from '@/components/atoms';

import { AuthWrapper } from '../AuthWrapper';
import { GlobalAuthenticatedBanners } from '../MainLayout/GlobalAuthenticatedBanners';
import { MainLayout } from '../MainLayout/MainLayout';

type RouteProps = {
  component: FC;
  withoutSidebar?: boolean;
};

export const Route: FC<RouteProps> = ({ component: Component, withoutSidebar }) => {
  if (withoutSidebar) {
    return (
      <Suspense fallback={<Loader />}>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <AuthWrapper>
            <ScrollRestoration getKey={location => location.pathname} />
            <GlobalAuthenticatedBanners />
            <Component />
          </AuthWrapper>
        </QueryParamProvider>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<Loader />}>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <AuthWrapper>
          <MainLayout>
            <ScrollRestoration getKey={location => location.pathname} />
            <Component />
          </MainLayout>
        </AuthWrapper>
      </QueryParamProvider>
    </Suspense>
  );
};
